import tempMeeApi from '../../../apis/tempMee';

// Uploads the payout CSV as multipart/form-data (field name `file`). The BE
// re-validates every row, queues the valid ones for async Stripe transfer, and
// returns the batch id, the queued count, and the skipped rows with reasons.
export const uploadPayouts = async (promotionId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await tempMeeApi.post(
    `/payment/admin/promotion-campaigns/${promotionId}/payouts`,
    formData,
  );

  return response.data;
};
